import React from 'react';
import { Pie, Text, PieChart, Cell, Tooltip, Legend } from 'recharts';
import { ChartColors } from './ChartColors';
import { Row } from 'reactstrap';

// BarChartComponent receives 'data' as a prop

const CustomXAxisTick = ({ x, y, payload }) => {
  if (payload && payload.value) {
    return (
      <Text
        fontSize={'12px'}
        width={'12px'}
        x={x}
        y={y}
        textAnchor='middle'
        verticalAnchor='start'
      >{payload.value}</Text>
    );
  }
  return null;
};
const RADIAN = Math.PI / 180;

const renderCustomizedLabel = ({
                                 cx, cy, midAngle, innerRadius, outerRadius, percent,
                               }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill='white' textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

const CustomLegend = ({ data }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', padding: 10 }}>
      {/* Iterate over data to display legend items */}
      {data.map((entry, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 4 }}>
          <div style={{
            width: 10,
            height: 10,
            backgroundColor: ChartColors[index % ChartColors.length],
            marginRight: 8,
          }}></div>
          <span style={{ fontSize: data.length > 5 ? '10px' : '12px' }}>{entry.name}</span>
        </div>
      ))}
    </div>
  );
};

const PieChartComponent = ({ data }) => {
  return (
    <Row>
      <PieChart
        width={200}
        height={200}>
        <Pie
          data={data}

          labelLine={false}
          label={renderCustomizedLabel}

          fill='#8884d8'
          dataKey='value'
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={ChartColors[index % ChartColors.length]} />
          ))}
        </Pie> <Tooltip />
        {/*<Legend layout='horizontal' verticalAlign='bottom' align='bottom' />*/}
      </PieChart>
      <CustomLegend data={data} />
    </Row>
  );
};

export default PieChartComponent;